/**
 * 商户统计
 */
<template>
  <div class="merchant-statistics-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户统计</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 每月总流水折线图 -->
    <el-card shadow="hover" class="total-flow-card chart-card">
      <div slot="header" class="chart-card-header total-flow-header">
        <div class="chart-title-left">
          <i class="el-icon-s-data header-icon"></i>
          <span>每月总流水</span>
        </div>
        <el-form :inline="true" size="small" class="total-flow-form">
          <el-form-item label="月份范围">
            <el-date-picker
              v-model="totalChartStartMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="开始月份"
              style="width: 120px"
            />
            <span class="range-sep">至</span>
            <el-date-picker
              v-model="totalChartEndMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="结束月份"
              style="width: 120px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" icon="el-icon-search" @click="fetchTotalFlowChart">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-loading="totalChartLoading" class="chart-body">
        <div ref="totalChartRef" class="chart-single-wrap"></div>
        <div v-if="!totalChartLoading && totalChartData.length === 0" class="chart-empty">
          <i class="el-icon-document"></i>
          <p>暂无数据</p>
        </div>
      </div>
    </el-card>

    <!-- 搜索筛选 -->
    <div class="search-section">
      <el-form
        :inline="true"
        :model="formInline"
        size="small"
        class="search-form"
        :rules="rules"
        ref="formRef"
      >
        <el-form-item label="商户类型">
          <el-select
            v-model="formInline.agentType"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(val, index) in merchantTypeList"
              :label="val.label"
              :value="val.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称">
          <el-select
            v-model="formInline.merchantName"
            filterable
            allow-create
            default-first-option
            placeholder="请选择或输入商户名称"
            @blur="selectMerchantNameBlur"
            class="search-input"
          >
            <el-option
              v-for="(val, index) in merchantList"
              :label="val"
              :value="val"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务商">
          <el-select
            v-model="formInline.disCompanyName"
            filterable
            allow-create
            default-first-option
            placeholder="请选择或输入服务商名称"
            @blur="selectDisCompanyBlur"
            class="search-input"
          >
            <el-option
              v-for="(val, index) in disCompanyList"
              :label="val.label"
              :value="val.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围" prop="date">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            :placeholder="`请选择时间范围，默认查当前月`"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="toolbar">
      <el-button type="primary" size="small" icon="el-icon-download" @click="exportdata">导出数据</el-button>
    </div>

    <el-card shadow="hover" class="table-card">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="加载中..."
        empty-text="暂无数据"
        style="width: 100%"
      >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->

      <el-table-column
        fixed
        prop="merchantName"
        label="商户名称"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column prop="serviceFee" label="总服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{
            scope.row.serviceFee ? scope.row.serviceFee.toFixed(2) : 0
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="月度流水" width="120" fixed="right">
        <template slot-scope="scope">
          <span class="view-text" @click="openFlowDialog(scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>

      <div class="summary-panel">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="m-bott-15">
              <span>总服务费：</span>
              <span>{{ formatNumber(currentPageSummary.totalService) }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="pagination-wrap">
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
      </div>
    </el-card>

    <!-- 月度流水弹窗 -->
    <el-dialog
      :title="flowDialogTitle"
      :visible.sync="flowDialogVisible"
      width="920px"
      append-to-body
      custom-class="flow-dialog"
      center
      @opened="onFlowDialogOpened"
      @closed="onFlowDialogClosed"
    >
      <div class="flow-dialog-form">
        <el-form :inline="true" size="small" class="flow-form-inline">
          <el-form-item label="月份范围">
            <el-date-picker
              v-model="flowStartMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="开始月份"
              style="width: 140px"
            />
            <span class="flow-form-sep">至</span>
            <el-date-picker
              v-model="flowEndMonth"
              type="month"
              value-format="yyyy-MM"
              placeholder="结束月份"
              style="width: 140px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchFlowData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="flow-chart-area">
        <div ref="flowChartRef" class="flow-chart-wrap" v-loading="flowLoading"></div>
        <div v-if="!flowLoading && flowChartData.length === 0" class="flow-empty">暂无数据</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  getMerchantStatistical,
  getSalesMerchantName,
  getDisCompanyNames,
  getMerchantMonthlyDistribution,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载

      // rules表单验证
      rules: {
        date: [
          { required: true, message: "请选择时间范围", trigger: "change" }, // 时间范围必输校验
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: this.getDefaultMonthRange(),
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      // 月度流水弹窗
      flowDialogVisible: false,
      flowMerchantName: "",
      flowMerchantId: null,
      flowStartMonth: "",
      flowEndMonth: "",
      flowChartData: [],
      flowChart: null,
      flowLoading: false,
      // 每月总流水折线图（不传商户 id = 该销售所有客户）
      totalChartStartMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-01`;
      })(),
      totalChartEndMonth: (() => {
        const n = new Date();
        return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}`;
      })(),
      totalChartData: [],
      totalChart: null,
      totalChartLoading: false,
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */
  computed: {
    flowDialogTitle() {
      return this.flowMerchantName ? `${this.flowMerchantName} - 月度流水` : "月度流水";
    },
    currentPageSummary() {
      // 底部汇总：总服务费按当页数据求和（处理 null/undefined 的情况）
      return this.listData.reduce(
        (acc, item) => {
          acc.totalService += Number(item.serviceFee) || 0;
          return acc;
        },
        { totalService: 0 }
      );
    },
  },
  /**
   * 创建完毕
   */
  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
    this.getdata(this.formInline);
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.totalChartRef) {
        this.totalChart = echarts.init(this.$refs.totalChartRef);
        this.fetchTotalFlowChart();
      }
    });
    window.addEventListener("resize", this.handleTotalChartResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleTotalChartResize);
    if (this.totalChart) {
      this.totalChart.dispose();
      this.totalChart = null;
    }
  },
  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
    reset() {
      this.formInline = {
        page: 1,
        pageSize: 10,
        merchantName: "",
        disCompanyName: "",
        agentType: "",
        date: this.getDefaultMonthRange(),
      };
      this.getdata(this.formInline);
    },
    // 获取公司列表
    getdata(formInline) {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }

      let params = {
        page: formInline.page,
        pageSize: formInline.pageSize,
        disCompanyName: formInline.disCompanyName,
        merchantName: formInline.merchantName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
      };
      getMerchantStatistical(params)
        .then((res) => {
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    getAgentTypeLabel(agentType) {
      const type = this.merchantTypeList.find(
        (item) => item.value === agentType
      );
      return type ? type.label : "未知";
    },
    exportdata() {
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }

      // 默认导出99999
      let params = {
        page: 1,
        pageSize: 99999,
        merchantName: this.formInline.merchantName,
        disCompanyName: this.formInline.disCompanyName,
        startDate: this.formInline.startDate,
        endDate: this.formInline.endDate,
        agentType: this.formInline.agentType,
        export: 1,
      };
      getMerchantStatistical(params)
        .then((res) => {
          if (res.msg == "success") {
            window.open(res.data.downloadUrl);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },

    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
    getDefaultMonthRange() {
      const now = new Date(); // 当前日期（包含时分秒）
      const start = new Date(now.getFullYear(), now.getMonth(), 1); // 当月1号（00:00:00）

      // 当天日期：保留年月日，时分秒置为0（可选，根据需求决定是否需要精确到天）
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 当天日期（00:00:00）
      // 或直接使用原始时间（包含当前时分秒）：const end = new Date(now);

      // 格式化函数（本地时间，YYYY-MM-DD）
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      return [formatDate(start), formatDate(end)]; // 返回格式化后的日期数组
    },
    // 生成从 startMonth 到 endMonth 的月份列表（yyyy-MM）
    getMonthRange(startMonth, endMonth) {
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const list = [];
      let y = y1;
      let m = m1;
      while (y < y2 || (y === y2 && m <= m2)) {
        list.push(`${y}-${String(m).padStart(2, "0")}`);
        if (m === 12) {
          y += 1;
          m = 1;
        } else {
          m += 1;
        }
      }
      return list;
    },
    // 默认当年1月到当前月（仅月份 yyyy-MM）
    getDefaultYearToCurrentMonth() {
      const now = new Date();
      const start = new Date(now.getFullYear(), 0, 1); // 当年1月
      const end = new Date(now.getFullYear(), now.getMonth(), 1); // 当前月
      const fmt = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, "0");
        return `${y}-${m}`;
      };
      return [fmt(start), fmt(end)];
    },
    openFlowDialog(row) {
      this.flowMerchantName = row.merchantName || "";
      this.flowMerchantId = row.merchantId != null ? row.merchantId : null;
      const [start, end] = this.getDefaultYearToCurrentMonth();
      this.flowStartMonth = start;
      this.flowEndMonth = end;
      this.flowDialogVisible = true;
    },
    onFlowDialogOpened() {
      this.$nextTick(() => {
        if (!this.flowChart && this.$refs.flowChartRef) {
          this.flowChart = echarts.init(this.$refs.flowChartRef);
        }
        this.fetchFlowData();
      });
    },
    onFlowDialogClosed() {
      this.flowChartData = [];
      if (this.flowChart) {
        this.flowChart.dispose();
        this.flowChart = null;
      }
    },
    fetchFlowData() {
      const startMonth = this.flowStartMonth;
      const endMonth = this.flowEndMonth;
      if (!startMonth || !endMonth) {
        this.$message.warning("请选择月份范围");
        return;
      }
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning("结束月份不能早于开始月份");
        return;
      }
      if (monthDiff > 24) {
        this.$message.warning("时间间隔不能超过两年");
        return;
      }
      this.flowLoading = true;
      const params = { startDate: startMonth, endDate: endMonth };
      if (this.flowMerchantId != null && this.flowMerchantId !== "") {
        params.merchantId = this.flowMerchantId;
      } else {
        params.merchantName = this.flowMerchantName;
      }
      getMerchantMonthlyDistribution(params)
        .then((res) => {
          if (res.msg === "success" && res.data) {
            const items = Array.isArray(res.data) ? res.data : res.data.items || [];
            const dataByMonth = {};
            items.forEach((d) => {
              const m = (d.yearMonth || d.month || d.monthKey || "").toString();
              if (m) dataByMonth[m] = d;
            });
            const fullMonths = this.getMonthRange(startMonth, endMonth);
            this.flowChartData = fullMonths.map((ym) => {
              const d = dataByMonth[ym];
              const label = ym.length >= 7 && ym.indexOf("-") !== -1 ? ym.replace("-", "年") + "月" : ym;
              if (d) return { ...d, monthLabel: label };
              return { yearMonth: ym, monthLabel: label, preTaxAmount: 0, batchCount: 0 };
            });
            this.renderFlowChart();
          } else {
            this.flowChartData = this.getMonthRange(startMonth, endMonth).map((ym) => ({
              yearMonth: ym,
              monthLabel: ym.replace("-", "年") + "月",
              preTaxAmount: 0,
              batchCount: 0,
            }));
            this.renderFlowChart();
          }
        })
        .catch(() => {
          this.flowChartData = this.getMonthRange(startMonth, endMonth).map((ym) => ({
            yearMonth: ym,
            monthLabel: ym.replace("-", "年") + "月",
            preTaxAmount: 0,
            batchCount: 0,
          }));
          this.renderFlowChart();
        })
        .finally(() => {
          this.flowLoading = false;
        });
    },
    renderFlowChart() {
      if (!this.flowChart) return;
      const aggregated = this.flowChartData;
      const months = aggregated.map((d) => d.yearMonth);
      const monthLabels = aggregated.map((d) => d.monthLabel);
      const values = aggregated.map((d) => {
        const v = Number(d.preTaxAmount);
        if (v != null && !isNaN(v)) return v;
        return Number(d.batchCount) != null && !isNaN(Number(d.batchCount)) ? Number(d.batchCount) : Number(d.count) || 0;
      });
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "line" },
          formatter: (params) => {
            if (!params || !params.length) return "";
            const idx = params[0].dataIndex;
            const ym = months[idx] || "";
            const val = values[idx] != null ? values[idx] : 0;
            return `${ym}<br/>当月服务费：${Number(val).toFixed(2)} 元`;
          },
        },
        grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
        xAxis: {
          type: "category",
          data: monthLabels.length ? monthLabels : ["暂无数据"],
          axisLine: { lineStyle: { color: "#e4e7ed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        yAxis: {
          type: "value",
          name: "流水(元)",
          nameTextStyle: { color: "#606266", fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0", type: "dashed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        series: [
          {
            name: "流水",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            data: values.length ? values : [0],
            itemStyle: { color: "#409EFF" },
            lineStyle: { width: 2 },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(64, 158, 255, 0.25)" },
                  { offset: 1, color: "rgba(64, 158, 255, 0.02)" },
                ],
              },
            },
          },
        ],
      };
      this.flowChart.setOption(option, true);
      this.$nextTick(() => this.flowChart && this.flowChart.resize());
    },
    // 每月总流水：不传商户 id，该销售名下所有客户汇总
    fetchTotalFlowChart() {
      const startMonth = this.totalChartStartMonth;
      const endMonth = this.totalChartEndMonth;
      if (!startMonth || !endMonth) {
        this.totalChartData = [];
        this.renderTotalChart();
        return;
      }
      const [y1, m1] = startMonth.split("-").map(Number);
      const [y2, m2] = endMonth.split("-").map(Number);
      const monthDiff = (y2 - y1) * 12 + (m2 - m1);
      if (monthDiff < 0) {
        this.$message.warning("结束月份不能早于开始月份");
        return;
      }
      if (monthDiff > 24) {
        this.$message.warning("时间间隔不能超过两年");
        return;
      }
      this.totalChartLoading = true;
      getMerchantMonthlyDistribution({ startDate: startMonth, endDate: endMonth })
        .then((res) => {
          if (res.msg === "success" && res.data) {
            const items = Array.isArray(res.data) ? res.data : res.data.items || [];
            const sumByMonth = {};
            items.forEach((d) => {
              const ym = (d.yearMonth || d.month || d.monthKey || "").toString();
              if (!ym) return;
              const amt = Number(d.preTaxAmount);
              sumByMonth[ym] = (sumByMonth[ym] || 0) + (isNaN(amt) ? 0 : amt);
            });
            const fullMonths = this.getMonthRange(startMonth, endMonth);
            this.totalChartData = fullMonths.map((ym) => {
              const label = ym.replace("-", "年") + "月";
              return { yearMonth: ym, monthLabel: label, totalAmount: sumByMonth[ym] || 0 };
            });
            this.renderTotalChart();
          } else {
            this.totalChartData = this.getMonthRange(startMonth, endMonth).map((ym) => ({
              yearMonth: ym,
              monthLabel: ym.replace("-", "年") + "月",
              totalAmount: 0,
            }));
            this.renderTotalChart();
          }
        })
        .catch(() => {
          this.totalChartData = this.getMonthRange(startMonth, endMonth).map((ym) => ({
            yearMonth: ym,
            monthLabel: ym.replace("-", "年") + "月",
            totalAmount: 0,
          }));
          this.renderTotalChart();
        })
        .finally(() => {
          this.totalChartLoading = false;
        });
    },
    renderTotalChart() {
      if (!this.totalChart) return;
      const aggregated = this.totalChartData;
      const months = aggregated.map((d) => d.yearMonth);
      const monthLabels = aggregated.map((d) => d.monthLabel);
      const values = aggregated.map((d) => (d.totalAmount != null ? Number(d.totalAmount) : 0));
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "line" },
          formatter: (params) => {
            if (!params || !params.length) return "";
            const idx = params[0].dataIndex;
            const ym = months[idx] || "";
            const val = aggregated[idx] ? aggregated[idx].totalAmount : 0;
            return `${ym}<br/>当月服务费：${Number(val).toFixed(2)} 元`;
          },
        },
        grid: { left: 56, right: 32, bottom: 36, top: 36, containLabel: true },
        xAxis: {
          type: "category",
          data: monthLabels.length ? monthLabels : ["暂无数据"],
          axisLine: { lineStyle: { color: "#e4e7ed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        yAxis: {
          type: "value",
          name: "流水(元)",
          nameTextStyle: { color: "#606266", fontSize: 12 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: "#f0f0f0", type: "dashed" } },
          axisLabel: { color: "#606266", fontSize: 12 },
        },
        series: [
          {
            name: "总流水",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 6,
            data: values.length ? values : [0],
            itemStyle: { color: "#409EFF" },
            lineStyle: { width: 2 },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(64, 158, 255, 0.25)" },
                  { offset: 1, color: "rgba(64, 158, 255, 0.02)" },
                ],
              },
            },
          },
        ],
      };
      this.totalChart.setOption(option, true);
      this.$nextTick(() => this.totalChart && this.totalChart.resize());
    },
    handleTotalChartResize() {
      this.totalChart && this.totalChart.resize();
    },
  },
};
</script>

<style scoped>
.merchant-statistics-page {
  padding-bottom: 24px;
}
.page-breadcrumb {
  margin-bottom: 0;
}
.total-flow-card {
  margin-top: 8px;
  margin-bottom: 16px;
}
.chart-card {
  border-radius: 8px;
  overflow: hidden;
}
.chart-card >>> .el-card__header {
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
}
.chart-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chart-title-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chart-card-header .header-icon {
  font-size: 18px;
  color: #409eff;
}
.chart-card >>> .el-card__body {
  padding: 20px;
}
.total-flow-header {
  flex-wrap: wrap;
  gap: 12px;
}
.total-flow-form {
  margin: 0;
}
.total-flow-form .el-form-item {
  margin-bottom: 0;
}
.range-sep {
  margin: 0 6px;
  color: #606266;
}
.chart-body {
  min-height: 320px;
  position: relative;
}
.chart-single-wrap {
  width: 100%;
  height: 320px;
}
.chart-empty {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 6px;
  color: #c0c4cc;
}
.chart-empty i {
  font-size: 40px;
  margin-bottom: 8px;
}
.chart-empty p {
  margin: 0;
  font-size: 14px;
  color: #909399;
}

/* 搜索区、表格、按钮 - 与销售主管风格一致 */
.search-section {
  margin-top: 0;
  margin-bottom: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}
.search-form .el-form-item {
  margin-bottom: 10px;
  margin-right: 20px;
}
.search-form .search-input {
  width: 220px;
}
.toolbar {
  margin: 16px 0;
}
.table-card {
  border-radius: 8px;
  overflow: hidden;
}
.table-card >>> .el-card__body {
  padding: 20px;
}
.summary-panel {
  margin-top: 16px;
  padding-top: 8px;
  border-top: 1px solid #ebeef5;
}
.summary-panel .m-bott-15 {
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}
.pagination-wrap {
  margin-top: 16px;
}

.view-text {
  color: #409eff; /* Element UI 按钮默认颜色 */
  cursor: pointer; /* 鼠标指针样式 */
  text-decoration: none;
  display: inline-block;
  padding: 0 3px;
  line-height: 1;
}

.view-text:hover {
  color: #66b1ff; /* Element UI 按钮悬停颜色 */
  text-decoration: underline;
}

.flow-dialog-form {
  margin-bottom: 20px;
  padding: 16px 0 20px 24px;
}
.flow-form-inline .el-form-item {
  margin-bottom: 0;
  margin-right: 16px;
}
.flow-form-sep {
  margin: 0 10px;
  color: #909399;
}
.flow-chart-area {
  min-height: 440px;
  margin-top: 4px;
  padding-left: 24px;
  overflow: visible;
}
.flow-chart-wrap {
  width: 100%;
  height: 440px;
}
.flow-empty {
  text-align: center;
  color: #909399;
  padding: 100px 0;
}

</style>
<style>
/* 月度流水弹窗：整体宽松、居中，内容区留足空间 */
.flow-dialog.el-dialog {
  margin-top: 8vh !important;
}
.flow-dialog.el-dialog .el-dialog__header {
  padding: 18px 24px 14px;
  border-bottom: 1px solid #ebeef5;
}
.flow-dialog.el-dialog .el-dialog__body {
  padding: 24px 28px 28px 16px;
  max-height: 72vh;
  overflow-y: auto;
}
.flow-dialog.el-dialog .el-dialog__title,
.flow-dialog.el-dialog .el-dialog__header .el-dialog__title {
  font-size: 16px;
  color: #303133;
}
</style>

 


// WEBPACK FOOTER //
// src/views/sales/salesMerchantStatistics.vue